module.exports = __webpack_public_path__ + "static/Poppins-Bold-38a67be189c58dfc5367a081b54ebcc8.woff2";